/* eslint-disable import/no-default-export */
import React from 'react';
import ReactionAlerts from './reactions-alerts';

const Alerts: React.FunctionComponent = () => {
  return <ReactionAlerts />;
};

export default Alerts;



// WEBPACK FOOTER //
// ./app/gamma/src/components/alerts/index.tsx